import React, { useCallback, useEffect, useState } from "react";
import styles from "../../../../styles/water-management/dashboard.module.css";
import { monthSort } from "../../../../utils/constant";
import LineChart from "../../../../Components/GraphNCharts/LineChart";
import PieChart from "../../../../Components/GraphNCharts/Pie";
import { Box } from "@mui/material";
import EchartDoughnutChart from "../../../../Components/GraphNCharts/EchartDoughnut";
import { get } from "../../../../utils/api";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import WaterManagement from "../../../../Layout/WaterManagement";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { manipulateDataForBarChart } from "../../../../utils/graphFunctions";
import { useUser } from "../../../../context/AuthContext";
import PeriodFilter from "../../../../Components/Common/PeriodFilter";
import {
  generateAnnualLabels,
  generateMonthYearLabels,
} from "../../../../utils/generateYearRanges";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";
import useAuthStore from "../../../../store/ContextUser";
import GroupAdminSidebar from "../../../../Layout/GroupAdminSidebar";
const Dashboard = () => {
  const { user } = useUser();
  const { selectedCompany } = useAuthStore();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [facilityList, setFacilities] = useState([]);

  const [dashboardData, setDashboardData] = useState({
    withdrawal: null,
    discharge: null,
    reuserecycle: null,
    totalChart: null,
  });

  const [waterWithdrawal, setWaterWithdrawal] = useState({});

  const [waterDischarge, setWaterDischarge] = useState({
    source: {
      name: [],
      value: [],
    },
    monthlyData: [],
    annualData: [],
  });

  const [totalWaterRecycled, setTotalWaterRecycled] = useState({
    waterRecycled: [],
    totalWaterRecycled: [],
    monthlyRecycled: "",
    totalConsumed: "",
    monthlyRecycledData: "",
    waterConsumed: "",
    recycledData: "",
    monthlyWaterConsumed: "",
  });

  const [graphView, setGraphView] = useState({
    withdrawal: "Annual",
    discharge: "Annual",
    totalWaterRecycled: "Annual",
  });

  const [withdrawalData, setWithdrawalData] = useState(null);
  const [dischargeData, setDischargeData] = useState(null);
  const [reuserecycleData, setReuserecycleData] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState([]);

  const apiUrls = {
    withdrawal: `/scope3/waterManagement/dashboard/waterWithdrawal?startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility}&companyId=${selectedCompany?._id}`,
    discharge: `/scope3/waterManagement/dashboard/waterDischargeByDestination?facility=${selectedFacility}&companyId=${selectedCompany?._id}`,
    reuserecycle: `/scope3/waterManagement/main/dashboard/mainRecyleAndReused1?startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility}&companyId=${selectedCompany?._id}`,
    totalChart: `/scope3/waterManagement/dashboard/total?startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility}&companyId=${selectedCompany?._id}`,
  };

  const colorList = [
    { label: "Surface Water", color: "#FF4444" },
    { label: "Ground Water", color: "#0066E7" },
    { label: "Seawater", color: "#FFBB33" },
    { label: "Industrial Produced Water", color: "#9D2DED" },
    { label: "Third-party water", color: "#17D451" },
    { label: "Others", color: "#6C679A" },
  ];

  const fetchData = async () => {
    try {
      const [discharge, withdrawal, reuserecycle, totalChart] =
        await Promise.all([
          get(apiUrls.discharge),
          get(apiUrls.withdrawal),
          get(apiUrls.reuserecycle),
          get(apiUrls.totalChart),
        ]);

      setDashboardData({
        discharge: discharge.data,
        withdrawal: withdrawal.data,
        reuserecycle: reuserecycle.data,
        totalChart: totalChart.data,
      });
    } catch (error) {
      console.log("first", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, selectedFacility, selectedCompany]);

  // useEffect(() => {
  //   if (facilityList.length > 0 && user?.companyAdmin) {
  //     setSelectedFacility(facilityList[0]);
  //   }
  // }, [facilityList]);

  // useEffect(() => {
  //   const currentDate = new Date();
  //   setMonth(String(currentDate.getMonth() + 1));
  //   setYear(currentDate.getFullYear());
  // }, []);

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);

  const fetchData1 = useCallback(async () => {
    try {
      const res = await get(
        `/scope3/waterManagement/main/dashboard/waterWithdrawal?startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility}&companyId=${selectedCompany?._id}`
      );

      // ).then((res) => {
      //   const { monthlySum, last5YearData, annualData } = res?.data;
      //   const sourceNames = [];
      //   const sourceValues = [];
      //   let othersValue = 0;

      //   monthlySum.forEach((item) => {
      //     if (predefinedSources.includes(item.source)) {
      //       sourceNames.push(item.source);
      //       sourceValues.push(item.totalQuantity);
      //     } else {
      //       othersValue += item.totalQuantity;
      //     }
      //   });

      //   if (othersValue > 0) {
      //     sourceNames.push("Others");
      //     sourceValues.push(othersValue);
      //   }

      //   const transformedData = transformData(annualData);
      //   const yearsList = extractYears(last5YearData);

      //   let yearlyData = transformYearlyData(last5YearData);
      //   let waterSources = [
      //     "Third-party water",
      //     "Industrial Produced Water",
      //     "Seawater",
      //     "Surface Water",
      //     "Ground Water",
      //     "Others",
      //   ];

      //   let monthlyData = convertToDataset(
      //     transformedData,
      //     colorList,
      //     waterSources
      //   );

      //   let yearlyDataList = convertToDataset(
      //     yearlyData,
      //     colorList,
      //     waterSources
      //   );

      //   console.log( sourceNames,
      //   sourceValues,
      //    monthlyData,
      //     yearsList,
      //      yearlyDataList,
      //  "p11")
      setWaterWithdrawal(res?.data);
    } catch (error) {
      console.log("first", error);
    }
  }, [toDate, fromDate, selectedFacility, selectedCompany]);

  const fetchData2 = useCallback(async () => {
    try {
      const res = await get(
        `/scope3/waterManagement/main/dashboard/waterDischarg?startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility}&companyId=${selectedCompany?._id}`
      );
      // .then((res) => {
      //   const { monthlySum, last5YearData, annualData } = res?.data;

      //   const sourceNames = [];
      //   const sourceValues = [];
      //   let othersValue = 0;

      //   monthlySum.forEach((item) => {
      //     if (predefinedSources.includes(item._id)) {
      //       sourceNames.push(item._id);
      //       sourceValues.push(item.totalQuantity);
      //     } else {
      //       othersValue += item.totalQuantity;
      //     }
      //   });

      //   if (othersValue > 0) {
      //     sourceNames.push("Others");
      //     sourceValues.push(othersValue);
      //   }

      //   let waterSources = [
      //     "Surface Water",
      //     "Ground Water",
      //     "Seawater",
      //     "Municipal Treatment Plant - ETP",
      //     "STP",
      //     "Others",
      //   ];

      //   const transformedData = transformData(annualData);
      //   const yearsList = extractYears(last5YearData);

      //   let yearlyData = transformYearlyData(last5YearData);

      //   let monthlyData = convertToDataset(
      //     transformedData,
      //     colorListDischarge,
      //     waterSources
      //   );

      //   let yearlyDataList = convertToDataset(
      //     yearlyData,
      //     colorListDischarge,
      //     waterSources
      //   );
      setWaterDischarge(res?.data);
    } catch (error) {
      console.log("second", error);
    }
  }, [toDate, fromDate, selectedFacility, selectedCompany]);

  const fetchData3 = useCallback(async () => {
    try {
      const res = await get(
        `scope3/waterManagement/main/dashboard/mainRecyleAndReused?startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility}&companyId=${selectedCompany?._id}`
      );
      // .then((res) => {
      //   console.log("thirdres", JSON.stringify(res?.data?.annualData));
      //   const {
      //     monthlySum,
      //     last5yearWaterConsumed,
      //     lastFiveYearResult,
      //     monthlyTotalWater,
      //     annualData,
      //     annualWaterConsumed,
      //   } = res?.data;

      //   const yearsList = extractYears(last5yearWaterConsumed);
      //   console.log("inside11", yearsList);

      //   const extractTotalQuantities = (data) => {
      //     return data.length > 0
      //       ? data[0].yearlyData.map((yearData) => yearData.totalQuantity)
      //       : [];
      //   };

      //   const extractMonthlyTotals = (data) => {
      //     return data.length > 0
      //       ? data[0].monthlyData.map((monthData) => monthData.totalQuantity)
      //       : [];
      //   };

      //   const waterConsumed = extractTotalQuantities(last5yearWaterConsumed);
      //   const recycledData = extractTotalQuantities(lastFiveYearResult);

      //   const monthlyWaterConsumed = extractMonthlyTotals(annualWaterConsumed);
      //   const monthlyRecycledData = extractMonthlyTotals(annualData);
      setTotalWaterRecycled(res?.data);
      // });
    } catch (error) {
      console.log("third", error);
    }
  }, [toDate, fromDate, selectedFacility, selectedCompany]);

  useEffect(() => {
    fetchData1();
    fetchData2();
    fetchData3();
  }, [fetchData1, fetchData2, fetchData3, selectedCompany]);

  let waterWithdrawalDataset = manipulateDataForBarChart({
    data: withdrawalData || [],
    colors: colorList,
    type: "withdrawal",
  });

  let waterDischargeDataset = manipulateDataForBarChart({
    data: dischargeData || [],
    colors: colorList,
    type: "discharge",
  });

  useEffect(() => {
    let data = dashboardData?.withdrawal?.data || [];
    let dataMap = new Map();

    let others = new Array(12).fill(null).map((_, i) => ({
      month: i + 1,
      total: 0,
    }));

    const activityArr = [
      "Surface Water",
      "Ground Water",
      "Seawater",
      "Industrial Produced Water",
      "Third-party water",
    ];

    data.forEach((item) => {
      if (activityArr.includes(item.source)) {
        dataMap.set(item.source, item);
      } else {
        item.data.forEach((month, i) => {
          others[i].total += month.total;
        });
      }
    });
    let completeData = activityArr.map(
      (category) =>
        dataMap.get(category) || {
          source: category,
          data: new Array(12).fill(null).map((_, i) => ({
            month: i + 1,
            total: 0,
          })),
        }
    );
    if (others.some((month) => month.total > 0)) {
      completeData.push({ source: "Others", data: others });
    }
    setWithdrawalData(completeData);
  }, [dashboardData, selectedCompany]);

  useEffect(() => {
    let data = dashboardData?.discharge?.data || [];
    let dataMap = new Map();

    let others = new Array(12).fill(null).map((_, i) => ({
      month: i + 1,
      total: 0,
    }));

    const activityArr = [
      "Surface Water",
      "Ground Water",
      "Seawater",
      "Industrial Produced Water",
      "Third-party water",
    ];

    data.forEach((item) => {
      if (activityArr.includes(item.source)) {
        dataMap.set(item.source, item);
      } else {
        item.data.forEach((month, i) => {
          others[i].total += month.total;
        });
      }
    });
    let completeData = activityArr.map(
      (category) =>
        dataMap.get(category) || {
          source: category,
          data: new Array(12).fill(null).map((_, i) => ({
            month: i + 1,
            total: 0,
          })),
        }
    );
    if (others.some((month) => month.total > 0)) {
      completeData.push({ source: "Others", data: others });
    }
    setDischargeData(completeData);
  }, [dashboardData, selectedCompany]);

  const fetchFacilityList = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/purchasegoods/facilitylist?companyId=${selectedCompany?._id}`
      );
      if (user?.companyAdmin) {
        setFacilities(res?.data?.data.map((item) => item.facilityName));
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFacilityList();
  }, [selectedCompany]);

  const sourceArray = [
    { source: "Surface Water", color: "#FF4444" },
    { source: "Ground Water", color: "#0066E7" },
    { source: "Seawater", color: "#FFBB33" },
    { source: "Industrial Produced Water", color: "#9D2DED" },
    { source: "Third-party water", color: "#A6CDC6" },
    { source: "STP", color: "#17D451" },
    { source: "Municipal Treatment Plant - ETP", color: "#800000" },
  ];

  const recycleColor = ["#0066E7", "#D1D1D1"];
  const list = [
    {
      graphTitle: "Water withdrawal volumes by source over time",
      graph: "withdrawal",
      dataset:
        graphView?.withdrawal === "Annual"
          ? waterWithdrawal?.annualData
              ?.map((el) =>
                el?.data?.map((e) => e?.totalQuantity)?.filter(Boolean)
              )
              ?.filter(Boolean)?.length > 0
            ? waterWithdrawal?.annualData?.map((el, i) => ({
                label: el?.source,
                data: el?.data?.map((el) => el?.totalQuantity),
                borderColor: sourceArray?.find((e) => e?.source === el.source)
                  ?.color,
                backgroundColor: sourceArray?.find(
                  (e) => e?.source === el.source
                )?.color,
                tension: 0.4,
                fill: true,
                pointRadius: 0,
              }))
            : []
          : waterWithdrawal?.last5YearData
              ?.map((el) =>
                el?.yearlyData?.map((e) => e?.totalQuantity).filter(Boolean)
              )
              ?.filter(Boolean)?.length > 0
          ? waterWithdrawal?.last5YearData?.map((el, i) => ({
              label: el?.source,
              data: el?.yearlyData?.map((el) => el?.totalQuantity) || 0,
              borderColor: sourceArray?.find((e) => e?.source === el.source)
                ?.color,
              backgroundColor: sourceArray?.find((e) => e?.source === el.source)
                ?.color,
              tension: 0.4,
              fill: true,
              pointRadius: 0,
            }))
          : [],
      datalabel:
        graphView?.withdrawal === "Year on Year"
          ? waterWithdrawal?.last5YearData?.[0]?.yearlyData.length > 0
            ? waterWithdrawal?.last5YearData?.[0]?.yearlyData?.map(
                (el) => el?.year
              )
            : generateAnnualLabels()
          : waterWithdrawal.annualData?.[0]?.data?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            ) || generateMonthYearLabels(fromDate, toDate),

      chartTitle: "Total water withdrawal by each source (KL)",
      chartValue: `${truncateNumber(
        dashboardData?.totalChart?.data
          ?.find((item) => item?.type === "Water Withdrawal")
          ?.data?.map((item) => item?.total)
          .reduce((acc, curr) => acc + curr, 0) ?? 0
      )}`,
      colors:
        dashboardData?.totalChart?.data?.length > 0 &&
        dashboardData?.totalChart?.data
          ?.find((item) => item?.type === "Water Withdrawal")
          .data?.map(
            (el) => sourceArray?.find((e) => el?.label === e.source)?.color
          ),
      customHeight: "24rem",
      customHeight1: "11rem",
      labels:
        dashboardData?.totalChart?.data
          ?.find((item) => item?.type === "Water Withdrawal")
          ?.data?.map((item) => item?.label) || [],
      values:
        dashboardData?.totalChart?.data
          ?.find((item) => item?.type === "Water Withdrawal")
          ?.data?.map((item) => item?.total) || [],
    },
    {
      graph: "discharge",
      dataset:
        graphView?.discharge === "Annual"
          ? waterDischarge?.annualData?.length > 0
            ? waterDischarge?.annualData?.map((el, i) => ({
                label: el?.source,
                data: el?.data?.map((el) => el?.totalQuantity) || 0,
                borderColor: sourceArray?.find((e) => e?.source === el.source)
                  ?.color,
                backgroundColor: sourceArray?.find(
                  (e) => e?.source === el.source
                )?.color,
                tension: 0.4,
                fill: true,
                pointRadius: 0,
              }))
            : []
          : waterDischarge?.last5YearData?.length > 0
          ? waterDischarge?.last5YearData?.map((el, i) => ({
              label: el?.source,
              data: el?.yearlyData?.map((el) => el?.totalQuantity) || 0,
              borderColor: sourceArray?.find((e) => e?.source === el.source)
                ?.color,
              backgroundColor: sourceArray?.find((e) => e?.source === el.source)
                ?.color,
              tension: 0.4,
              fill: true,
              pointRadius: 0,
            }))
          : [],
      datalabel:
        graphView?.discharge === "Year on Year"
          ? waterDischarge?.last5YearData?.[0]?.yearlyData?.map(
              (el) => el?.year
            ) || generateAnnualLabels(currentYear)
          : waterDischarge.annualData?.[0]?.data?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            ) || generateMonthYearLabels(fromDate, toDate),
      graphTitle: "Water discharge volumes by destination over time",
      chartTitle: "Total Water Discharge by Destination (KL)",
      chartValue: `${formatNumberCommaSeparated(
        dashboardData?.totalChart?.data
          ?.find((item) => item?.type === "Water Discharge")
          ?.data?.map((item) => item?.total)
          .reduce((acc, curr) => acc + curr, 0) ?? 0
      )}`,
      customHeight: "24rem",
      customHeight1: "11rem",
      yAxis: "",
      colors:
        dashboardData?.totalChart?.data?.length > 0 &&
        dashboardData?.totalChart?.data
          ?.find((item) => item?.type === "Water Discharge")
          .data?.map(
            (el) => sourceArray?.find((e) => el?.label === e.source)?.color
          ),
      labels:
        dashboardData?.totalChart?.data
          ?.find((item) => item?.type === "Water Discharge")
          ?.data?.map((item) => item?.label) || [],
      values:
        dashboardData?.totalChart?.data
          ?.find((item) => item?.type === "Water Discharge")
          ?.data?.map((item) => item?.total) || [],
    },
    {
      graph: "totalWaterRecycled",
      dataset:
        graphView?.totalWaterRecycled === "Annual"
          ? dashboardData?.reuserecycle?.annualWaterUsed
              ?.map((el) => el?.data?.map((e) => e?.total)?.filter(Boolean))
              ?.filter(Boolean)?.length > 0
            ? dashboardData?.reuserecycle?.annualWaterUsed?.map((el, i) => ({
                label: el?.source,
                data: el?.data?.map((el) => el?.total) || 0,
                borderColor: recycleColor[i],
                backgroundColor: recycleColor[i],
                tension: 0.4,
                fill: true,
                pointRadius: 0,
              }))
            : []
          : dashboardData?.reuserecycle?.yearWaterUsed
              ?.map((el, i) =>
                el?.data?.map((el) => el?.total)?.filter(Boolean)
              )
              ?.filter(Boolean)?.length > 0
          ? dashboardData?.reuserecycle?.yearWaterUsed?.map((el, i) => ({
              label: el?.source,
              data: el?.data?.map((el) => el?.total) || 0,
              borderColor: recycleColor[i],
              backgroundColor: recycleColor[i],
              tension: 0.4,
              fill: true,
              pointRadius: 0,
            }))
          : [],
      datalabel:
        graphView?.totalWaterRecycled === "Year on Year"
          ? dashboardData?.reuserecycle?.yearWaterUsed?.[0]?.data?.map(
              (el) => el?.year
            ) || generateAnnualLabels(currentYear)
          : dashboardData?.reuserecycle?.annualWaterUsed?.[0]?.data?.map(
              (el) =>
                monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
            ) || generateMonthYearLabels(fromDate, toDate),

      graphTitle: "Total volume of water recycled / reused over time",
      chartTitle: "Total water Consumed, Recycled/Reused (KL)",
      chartValue: `${formatNumberCommaSeparated(
        dashboardData?.reuserecycle?.totalData?.reduce(
          (acc, i) => acc + Number(i.total || 0),
          0
        )
      )}`,
      customHeight: "24rem",
      customHeight1: "14.1rem",
      yAxis: "",
      colors: ["#0066E7", "#D1D1D1"],
      values: [
        dashboardData?.reuserecycle?.totalData?.find(
          (el) => el?.source !== "Water Withdrawal"
        )?.total ?? 0,
        dashboardData?.reuserecycle?.totalData?.find(
          (el) => el?.source === "Water Withdrawal"
        )?.total ?? 0,
      ],
      labels: ["Water Recycled / Reused", "Total water Consumed"],
      customSet:
        [
          dashboardData?.reuserecycle?.totalData?.find(
            (el) => el?.source !== "Water Withdrawal"
          )?.total || 0,
          dashboardData?.reuserecycle?.totalData?.find(
            (el) => el?.source === "Water Withdrawal"
          )?.total || 0,
        ]?.filter(Boolean)?.length > 0
          ? [
              {
                data: [
                  dashboardData?.reuserecycle?.totalData?.find(
                    (el) => el?.source !== "Water Withdrawal"
                  )?.total ?? 0,
                  dashboardData?.reuserecycle?.totalData?.find(
                    (el) => el?.source === "Water Withdrawal"
                  )?.total ?? 0,
                ],
                backgroundColor: ["#0066E7", "#D1D1D1"],
                borderColor: "#fff",
                borderWidth: 0,
                offset: [0, 15],
              },
            ]
          : [],
    },
  ];

  const handleGraphChange = (e, type) => {
    if (type === "withdrawal") {
      setGraphView((prev) => ({ ...prev, withdrawal: e.target.value }));
    } else if (type === "discharge") {
      setGraphView((prev) => ({ ...prev, discharge: e.target.value }));
    } else if (type === "totalWaterRecycled") {
      setGraphView((prev) => ({ ...prev, totalWaterRecycled: e.target.value }));
    }
  };

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <WaterManagement />}
    >
      <Unauthorized requiredModule="Water management">
        <>
          <div className={styles.heading_container}>
            <p className={styles.heading}>Water Management</p>
            <PeriodFilter
              {...{
                fromDate,
                setFromDate,
                toDate,
                setToDate,
                yearList,
                setSelectedFacility,
                selectedFacility,
              }}
            />
          </div>

          {list.map((el) => (
            <Box sx={{ display: "flex", gap: 3 }}>
              <Box sx={{ width: "67%", height: "100%" }}>
                <div className={styles.graph_container}>
                  <div className={styles.cards}>
                    <div className={styles.cards_header}>
                      <p className={styles.emission_heading}>{el.graphTitle}</p>
                      <select
                        name="month"
                        id="month"
                        value={graphView[el?.graph]}
                        onChange={(e) => handleGraphChange(e, el?.graph)}
                        className={styles.heading_select_month}
                        style={{ width: "7.5rem" }}
                      >
                        {["Annual", "Year on Year"].map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                    </div>
                    <LineChart
                      dataset={el?.dataset}
                      customHeight={el.customHeight || "13rem"}
                      labels={el?.datalabel}
                      yAxisTitle={"Volume (kl)"}
                      display={true}
                    />
                  </div>
                </div>
              </Box>

              <Box sx={{ width: "33%" }}>
                <div className={styles.doughnut_container}>
                  <p
                    className={styles.card_subheading}
                    style={{ marginBottom: "1rem" }}
                  >
                    {el.chartTitle} :
                    <span className={styles.emission_heading_span}>
                      {" "}
                      {el.chartValue}
                    </span>
                  </p>
                  <Box
                    sx={{
                      width: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {el.chartTitle ===
                    "Total water Consumed, Recycled/Reused (KL)" ? (
                      <PieChart
                        labels={el.labels}
                        dataset={el.customSet}
                        customWidth={el.customSet?.length > 0 ? 170 : "100%"}
                        customHeight={
                          el.customSet?.length > 0 ? el.customHeight1 : "20rem"
                        }
                        mt={"50%"}
                      />
                    ) : (
                      <EchartDoughnutChart
                        labels={el.labels}
                        dataPoints={el.values}
                        colors={el.colors}
                        customWidth={"200px"}
                        customHeight={el?.customHeight1}
                        legendPosition="top"
                        mt={"40%"}
                      />
                    )}
                  </Box>
                  <div className={styles.stationary_chart_container}>
                    <div className={styles.doughnut_table_div}>
                      {(el.chartTitle ===
                      "Total water Consumed, Recycled/Reused (KL)"
                        ? el.customSet?.length > 0
                        : el?.values?.length > 0) &&
                        el.labels.map((item, index) => (
                          <div key={index} className={styles.table_container}>
                            <div className={styles.table_row}>
                              <span
                                className={styles.table_row_label}
                                style={{
                                  backgroundColor: el.colors[index],
                                }}
                              ></span>
                              <span className={styles.table_text}>{item}</span>
                            </div>
                            <span className={styles.table_text_val}>
                              {truncateNumber(el.values[index] ?? 0)}
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </Box>
            </Box>
          ))}

          {/* <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Box sx={{ width: "67%", height: "100%" }}>
              <div className={styles.graph_container}>
                <div className={styles.cards}>
                  <div className={styles.cards_header}>
                    <p className={styles.emission_heading}>
                      {"Total volume of water recycled / reused over time"}
                    </p>
                    <select
                      name="month"
                      id="month"
                      value={graphView["totalWaterRecycled"]}
                      onChange={(e) =>
                        handleGraphChange(e, "totalWaterRecycled")
                      }
                      className={styles.heading_select_month}
                    >
                      {["Annual", "Year on Year"].map((m) => (
                        <option key={m} value={m}>
                          {m}
                        </option>
                      ))}
                    </select>
                  </div>
                  <LineChart
                    dataset={totalWaterRecycled?.dataset}
                    customHeight={"15rem"}
                    labels={totalWaterRecycled?.datalabel}
                    yAxisTitle={"Volume (kl)"}
                    display={true}
                  />
                </div>
              </div>
            </Box>

            <Box sx={{ width: "33%" }}>
              <div className={styles.doughnut_container}>
                <p className={styles.card_subheading}>
                  {"Total water Consumed, Recycled/Reused"} :
                  <span className={styles.emission_heading_span}>
                    {" "}
                    {`${
                      (dashboardData?.reuserecycle?.totalData.find(
                        (item) => item.source === "Water Recycling"
                      )?.total ?? 0) +
                      (dashboardData?.reuserecycle?.totalData.find(
                        (item) => item.source === "Water Withdrawal"
                      )?.total ?? 0)
                    } KL`}
                  </span>
                </p>
                <Box
                  sx={{
                    width: "100%",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <PieChart
                    labels={["Water Recycled/Reused", "Total water Consumed"]}
                    dataset={[
                      {
                        data: [
                          dashboardData?.reuserecycle?.totalData.find(
                            (item) => item.source === "Water Recycling"
                          )?.total ?? 0,
                          dashboardData?.reuserecycle?.totalData.find(
                            (item) => item.source === "Water Withdrawal"
                          )?.total ?? 0,
                        ],
                        backgroundColor: ["#0066E7", "#D1D1D1"],
                        borderColor: "#fff",
                        borderWidth: 0,
                        offset: [0, 15],
                      },
                    ]}
                    customWidth={200}
                    customHeight={"auto"}
                  /> */}
          {/* </Box> */}
          {/* <div className={styles.stationary_chart_container}>
                  <div className={styles.doughnut_table_div}>
                    {["Water Recycled/Reused", "Total water Consumed"].map(
                      (item, index) => (
                        <div key={index} className={styles.table_container}>
                          <div className={styles.table_row}>
                            <span
                              className={styles.table_row_label}
                              style={{
                                backgroundColor: ["#0066E7", "#D1D1D1"][index],
                              }}
                            ></span>
                            <span className={styles.table_text}>{item}</span>
                          </div>
                          <span className={styles.table_text_val}>
                            {[
                              dashboardData?.reuserecycle?.totalData.find(
                                (item) => item.source === "Water Recycling"
                              )?.total ?? 0,
                              dashboardData?.reuserecycle?.totalData.find(
                                (item) => item.source === "Water Withdrawal"
                              )?.total ?? 0,
                            ][index] ?? 0}{" "}
                            KL
                          </span>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div> */}
          {/* </Box> */}
          {/* </Box> */}
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Dashboard;
